import styled from "@emotion/styled";
import { Dialog } from "@mui/material";
export const StyledDialog = styled(Dialog)(({ width }) => ({
  "& .MuiGrid-root": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  "& .MuiPaper-root": {
    borderRadius: "10px",
    width: width ? width : "500px",
  },
  fontFamily: "Inter",
}));

export const StyledMiniDialog = styled(Dialog)(({ width }) => ({
  "& .MuiGrid-root": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  fontFamily: "Inter",
}));
